var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencyEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 43.5V41.1667C44.6667 38.9922 43.1794 37.1651 41.1667 36.647M37.0833 22.8392C38.7936 23.5315 40 25.2082 40 27.1667C40 29.1251 38.7936 30.8018 37.0833 31.4941M38.8333 43.5C38.8333 41.3256 38.8333 40.2384 38.4781 39.3808C38.0045 38.2373 37.096 37.3289 35.9525 36.8552C35.0949 36.5 34.0077 36.5 31.8333 36.5H28.3333C26.1589 36.5 25.0717 36.5 24.2141 36.8552C23.0707 37.3289 22.1622 38.2373 21.6886 39.3808C21.3333 40.2384 21.3333 41.3256 21.3333 43.5M34.75 27.1667C34.75 29.744 32.6607 31.8333 30.0833 31.8333C27.506 31.8333 25.4167 29.744 25.4167 27.1667C25.4167 24.5893 27.506 22.5 30.0833 22.5C32.6607 22.5 34.75 24.5893 34.75 27.1667Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyEmpty);
export default __webpack_public_path__ + "static/media/agencyEmpty.4c4357d5247c0a6969949111d14b40c8.svg";
export { ForwardRef as ReactComponent };